const parseUrl = url => {
  const parsedUrl = url.replace(/(\/\/+)/g, '/').replace(/\/+$/, '');

  const lastUrlChar = parsedUrl.charAt(parsedUrl.length - 1);
  const hasQueryParam = parsedUrl.includes('?');

  if (lastUrlChar !== '/' && !hasQueryParam) {
    return `${parsedUrl}/`;
  }
  return parsedUrl;
};

const cleanUrl = (url = '') => {
  let parsedUrl = '';

  try {
    const urlParts = new URL(url);
    urlParts.pathname = parseUrl(urlParts.pathname);
    parsedUrl = urlParts.toString();
  } catch (e) {
    parsedUrl = parseUrl(url);
  }

  return parsedUrl;
};

export default cleanUrl;
